__turbopack_context__.v({
  "callToAction": "IwZSPW_callToAction",
  "callToActionButton": "IwZSPW_callToActionButton",
  "callToActionText": "IwZSPW_callToActionText",
  "closeButton": "IwZSPW_closeButton",
  "container": "IwZSPW_container",
  "dragBar": "IwZSPW_dragBar",
  "dragBarIndicator": "IwZSPW_dragBarIndicator",
  "flagStrip": "IwZSPW_flagStrip",
  "flagStripContainer": "IwZSPW_flagStripContainer",
  "form": "IwZSPW_form",
  "hidden": "IwZSPW_hidden",
  "modal": "IwZSPW_modal",
  "open": "IwZSPW_open",
  "panel": "IwZSPW_panel",
  "panelFlagStrip": "IwZSPW_panelFlagStrip",
  "panelHeader": "IwZSPW_panelHeader",
  "sentinel": "IwZSPW_sentinel",
});
